import { TIPO_IMOVEL } from '@/constants/TipoImovel'

export enum PRODUTOS_CREDITO_IMOBILIARIO {
	SAC = 1,
	PRICE = 2,
	POUPANCA_MAIS = 3
}

export enum AMORTIZATION_SYSTEMS {
	TODAS = 1,
	SAC = 2,
	PRICE = 3,
	MIX = 4
}

export enum RATE_TYPE {
	TODAS = 1,
	PADRAO = 2,
	POUPANCA = 3
}

/**
 * Retorna o nome do produto
 * @param produto
 * @returns String
 */
export function getProdutoDescricao(produto: PRODUTOS_CREDITO_IMOBILIARIO) {
	switch (produto) {
		case PRODUTOS_CREDITO_IMOBILIARIO.SAC:
			return 'SAC'
		case PRODUTOS_CREDITO_IMOBILIARIO.PRICE:
			return 'PRICE'
		case PRODUTOS_CREDITO_IMOBILIARIO.POUPANCA_MAIS:
			return 'POUPANCA MAIS'
	}
}

/**
 *  Return the amortization system description based on the property type
 * @param propertyType
 * @returns Array
 */
export function amortizationSystems(propertyType: number) {
	const amortizationSystems: { id: number; description: string }[] = []

	switch (propertyType) {
		case TIPO_IMOVEL.RESIDENCIAL:
			// If the property is residential, all amortization systems are available
			Object.entries(AMORTIZATION_SYSTEMS).forEach(([key, value]) => {
				if (isNaN(Number(key)))
					amortizationSystems.push({
						id: value as number,
						description: getAmortizationSystemDescription(value as AMORTIZATION_SYSTEMS)
					})
			})

			break

		case TIPO_IMOVEL.COMERCIAL:
		case TIPO_IMOVEL.TERRENO:
			// If the property is commercial or land, only the SAC and PRICE amortization systems are available
			Object.entries(AMORTIZATION_SYSTEMS)
				.filter(([, value]) => value !== AMORTIZATION_SYSTEMS.MIX)
				.forEach(([key, value]) => {
					if (isNaN(Number(key)))
						amortizationSystems.push({
							id: value as number,
							description: getAmortizationSystemDescription(value as AMORTIZATION_SYSTEMS)
						})
				})
			break
	}

	return amortizationSystems
}

/**
 * Return the rate types
 * @param  propertyType
 * @returns Array
 */
export function rateTypes(propertyType: number) {
	const rateTypes: { id: number; description: string }[] = []

	switch (propertyType) {
		case TIPO_IMOVEL.RESIDENCIAL:
			// If the property is residential, all rate types are available
			Object.entries(RATE_TYPE).forEach(([key, value]) => {
				if (isNaN(Number(key)))
					rateTypes.push({
						id: value as number,
						description: getRateTypeDescription(value as RATE_TYPE)
					})
			})

			break

		case TIPO_IMOVEL.COMERCIAL:
		case TIPO_IMOVEL.TERRENO:
			// If the property is commercial or land, only PADRAO is available
			Object.entries(RATE_TYPE)
				.filter(([, value]) => value == RATE_TYPE.PADRAO)
				.forEach(([key, value]) => {
					if (isNaN(Number(key)))
						rateTypes.push({
							id: value as number,
							description: getRateTypeDescription(value as RATE_TYPE)
						})
				})
			break
	}

	return rateTypes
}

/**
 * Return the amortization system name
 * @param amortizationSystem
 * @returns String
 */
export function getAmortizationSystemDescription(amortizationSystem: AMORTIZATION_SYSTEMS) {
	switch (amortizationSystem) {
		case AMORTIZATION_SYSTEMS.TODAS:
			return 'Todos'
		case AMORTIZATION_SYSTEMS.SAC:
			return 'SAC'
		case AMORTIZATION_SYSTEMS.PRICE:
			return 'PRICE'
		case AMORTIZATION_SYSTEMS.MIX:
			return 'Mix'
	}
}

/**
 * Return the amortization system name
 * @param rateType
 * @returns String
 */
export function getRateTypeDescription(rateType: RATE_TYPE) {
	switch (rateType) {
		case RATE_TYPE.TODAS:
			return 'Todos'
		case RATE_TYPE.PADRAO:
			return 'Padrão'
		case RATE_TYPE.POUPANCA:
			return 'Poupança'
	}
}
